<template>
  <div class="MobileFooter">
    <router-link :to="{ name: 'dashboard' }" class="MobileFooter-item">
      <ubi-icon class="Route-icon" name="home" />
      <span class="Route-title">{{ $t("layouts.home") }}</span>
    </router-link>
    <router-link :to="{ name: 'posts' }" class="MobileFooter-item">
      <ubi-icon class="Route-icon" name="announcement" />
      <span class="Route-title">{{ $t("layouts.ads") }}</span>
    </router-link>
    <router-link :to="{ name: 'portals' }" class="MobileFooter-item">
      <ubi-icon class="Route-icon" name="direction" />
      <span class="Route-title">{{ $t("layouts.portals") }}</span>
    </router-link>
    <router-link :to="{ name: 'profile' }" class="MobileFooter-item">
      <ubi-icon class="Route-icon" name="user" />
      <span class="Route-title">{{ $t("layouts.profile") }}</span>
    </router-link>
  </div>
</template>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.MobileFooter {
  background: $black;
  display: flex;
  align-items: stretch;
  overflow: hidden;

  &-item {
    @extend .p-2, .text-decoration-none;
    color: $white !important;
    flex: 1;
    text-align: center;
    .Route-title {
      font-size: $font-size-xs;
    }
    .Route-icon {
      @extend .pt-1;
      display: block;
      font-size: $font-size-base * 1.4;
    }

    &.router-link-exact-active {
      background: darken($black, 8%);
    }

    &--notifications .NotificationsButton {
      @extend .p-2;
      margin: map-get($spacers, 2) * -1;
      display: flex;
      flex-direction: column;

      .el-badge__content {
        top: 50%;
        left: 50%;
        right: auto;
        transform: translateY(-120%);
      }

      &-button {
        @extend .p-0, .pt-1;
        i {
          display: block;
          color: $white;
          font-size: $font-size-base * 1.4;
        }
      }

      &-label {
        font-size: $font-size-xs;
      }
    }
  }
}
</style>

<script>
import NotificationsButton from './notifications/NotificationsButton'
export default {
  name: 'MobileFooter',
  components: { NotificationsButton }
}
</script>
